import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { FormControl } from '@angular/forms';

import {
  DialogService,
  DialogStatus,
} from 'src/app/core/services/dialog.service';
import { AppDatePickerInputMaxType } from 'src/app/core/types/app-date-picker-input-max-type.type';
import { AppDatePickerInputMinType } from 'src/app/core/types/app-date-picker-input-min-type.type';
import { AppTimePickerInputMaxType } from 'src/app/core/types/app-time-picker-input-max-type.type';
import { AppTimePickerInputMinType } from 'src/app/core/types/app-time-picker-input-min-type.type';
import { DateTimeService } from '../../../core/services/date-time.service';

@Component({
    selector: 'app-date-time-picker',
    templateUrl: './date-time-picker.component.html',
    standalone: false
})
export class DateTimePickerComponent implements OnInit {
  //#region properties
  #dialogService = inject(DialogService);

  @Input() config: DateTimeConfig;
  @Input() disabled: boolean;
  @Output('dateTime') output_dateTimeValue = new EventEmitter<any>();

  date;
  time;
  dateTime;

  //#endregion

  constructor() {}

  ngOnInit() {
    if (this.config?.isDefaultValue) this.initValues();
    if (this.config?.dateTimeValue) this.separateDateAndTime();
  }

  ngOnChanges(): void {
    if (this.config?.isDefaultValue) this.initValues();
    if (this.config?.dateTimeValue) this.separateDateAndTime();
  }

  initValues() {
    this.date = 'today';
    this.time = 'now';
  }

  separateDateAndTime() {
    [this.date, this.time] = DateTimeService.separateDateTimeUTC(
      this.config?.dateTimeValue
    );
  }

  combineDateAndTime() {
    this.setMinTimeType();

    if (this.date && this.time)
      this.dateTime = DateTimeService.combineDateTimeToUTC(
        this.date?.toString().toUTC(),
        this.time
      );
    else this.dateTime = null;

    if (this.config?.isConvertToIsoString) {
      let _sendDate = new Date(this.date?.toString());
      let _sendTime = this.time.toString();
      _sendDate.setHours(_sendTime.split(':')[0], _sendTime.split(':')[1]);
      this.dateTime = _sendDate?.toISOString();
    }

    this.emitDateTime();
  }

  setMinTimeType() {
    //اگر حالت ویرایش نبود و تاریخ فعلی انتخاب شده بود باید ساعت برابر با ساعت جاری باشد
    const date = new Date(this.date).toDateString();
    const currentDate = new Date().toDateString();
    if (date == currentDate && !this.config.isEditMode) {
      this.config.minTimeType = 'now';
      if (this.time < DateTimeService.getCustomTime())
        this.time = DateTimeService.getCustomTime();
    } else this.config.minTimeType = 'custom';
  }

  showErrorDialog(event: any) {
    this.#dialogService.openDialog({
      title: 'common.error',
      message: event?.errorMessage,
      status: DialogStatus.error,
    });
  }

  emitDateTime() {
    this.output_dateTimeValue.emit(this.dateTime);
  }
}

export interface DateTimeConfig {
  isEditMode?: boolean;
  dateLabel?: string;
  timeLabel?: string;
  dateFormControl?: FormControl;
  timeFormControl?: FormControl;
  responsiveClassName?: string;
  dateTimeValue?: any;
  minDate?: any;
  maxDate?: any;
  minTime?: any;
  maxTime?: any;
  minDateType?: AppDatePickerInputMinType;
  maxDateType?: AppDatePickerInputMaxType;
  minTimeType?: AppTimePickerInputMinType;
  maxTimeType?: AppTimePickerInputMaxType;
  isDefaultValue?: boolean;
  isConvertToIsoString?: boolean;
  isAdvancedSearch?: boolean;
}
